"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.childrenToArray = childrenToArray;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _flattenDeep = _interopRequireDefault(require("lodash/fp/flattenDeep"));
function childrenToArray(children) {
  return (0, _flattenDeep["default"])(Array.isArray(children) ? children : _react["default"].Children.toArray(children));
}
var _default = exports["default"] = childrenToArray;